export const MICROSOFT_MANAGED_BUNDLES = [
  {
    minUserTier: "5",
    pricePerUser: "$42",
    license: "Microsoft 365 Business Premium",
    supportHours: "3",
  },
  {
    minUserTier: "10",
    pricePerUser: "$40",
    license: "Microsoft 365 Business Premium",
    supportHours: "5",
  },
  {
    minUserTier: "25",
    pricePerUser: "$65",
    license: "Microsoft 365 E3 with Teams",
    supportHours: "25",
  },
  {
    minUserTier: "25",
    pricePerUser: "$75",
    license: "Microsoft 365 E5 with Teams",
    supportHours: "25",
  },
];
